import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';

const Option = props => {
  const { innerRef, isFocused, isDisabled, isSelected, children, innerProps } = props;
  return (
    <MenuItem
      ref={innerRef}
      selected={isFocused}
      component="div"
      disabled={isDisabled}
      style={{
        maxWidth: '100%',
        fontWeight: isSelected ? 500 : 400
      }}
      {...innerProps}
    >
      {children}
    </MenuItem>
  );
};

Option.propTypes = {
  children: PropTypes.node,
  /**
   * props passed to the wrapping element for the group.
   */
  innerProps: PropTypes.shape({
    id: PropTypes.string.isRequired,
    key: PropTypes.string,
    onClick: PropTypes.func,
    onMouseMove: PropTypes.func,
    onMouseOver: PropTypes.func,
    tabIndex: PropTypes.number
  }).isRequired,
  /**
   * Inner ref to DOM Node
   */
  innerRef: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.any
    })
  ]),
  /**
   * Whether the option is focused.
   */
  isFocused: PropTypes.bool.isRequired,
  /**
   * Whether the option is selected.
   */
  isSelected: PropTypes.bool.isRequired
};

export default Option;
